import axios from 'axios';

export default axios.create({
  baseURL: `https://services.rusholts.ru/`,//YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
});
